import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class meiSimpleGas{
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 305,
        Id_Foritore: 3,
        Id_comodity: 2,
        TipoContratto:2,
        NomeOfferta: "GAS SIMPLE",
        LinkFoto: "./assets/images/offerte-mei/gas-simple.jpg",
        LinkFotoLarge: "./assets/images/offerte-mei/gas-simple.jpg",
        LinkFotoMid: "./assets/images/offerte-mei/gas-simple.jpg",
        LinkFotoSm: "./assets/images/offerte-mei/gas-simple.jpg",
        LinkFotoCarousel: "./assets/images/offerte-mei/gas-simple.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "L’offerta luce e gas che rispetta l’ambiente",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "VANTAGGI ASSICURATI",
            DescrizioneSezione: "ENERGIA AL 100% VERDE SENZA COSTI AGGIUNTI",
            lstPunti: []
          },
        ],
        PrezzoEle: 0,
        PrezzoGas: 0.3390,
       
        TitoloPlus: "VANTAGGI ASSICURATI",
        Plus: ["ENERGIA AL 100% VERDE SENZA COSTI AGGIUNTI"]
        ,schedaconfrontabilitaele:
      {
        tabellaConfrontabilita:[]
      }
      ,schedaconfrontabilitagas:  { tabellaConfrontabilita:[ { zona:1, consumoannuo:120,importo:102.77},{ zona:1, consumoannuo:480,importo:264.83},{ zona:1, consumoannuo:70,importo:358.82},{ zona:1, consumoannuo:1400,importo:657.86},{ zona:1, consumoannuo:2000,importo:912.4},{ zona:1, consumoannuo:5000,importo:2181.79} ,{ zona:2, consumoannuo:120,importo:93.02},{ zona:2, consumoannuo:480,importo:246.05},{ zona:2, consumoannuo:70,importo:334.87},{ zona:2, consumoannuo:1400,importo:617.46},{ zona:2, consumoannuo:2000,importo:857.86},{ zona:2, consumoannuo:5000,importo:2056.53} ,{ zona:3, consumoannuo:120,importo:99.25},{ zona:3, consumoannuo:480,importo:263.63},{ zona:3, consumoannuo:70,importo:358.91},{ zona:3, consumoannuo:1400,importo:662.06},{ zona:3, consumoannuo:2000,importo:920.12},{ zona:3, consumoannuo:5000,importo:2207.2} ,{ zona:4, consumoannuo:120,importo:94.68},{ zona:4, consumoannuo:480,importo:267.13},{ zona:4, consumoannuo:70,importo:366.89},{ zona:4, consumoannuo:1400,importo:684.28},{ zona:4, consumoannuo:2000,importo:954.59},{ zona:4, consumoannuo:5000,importo:2302.96} ,{ zona:5, consumoannuo:120,importo:107.54},{ zona:5, consumoannuo:480,importo:290.16},{ zona:5, consumoannuo:70,importo:395.56},{ zona:5, consumoannuo:1400,importo:730.92},{ zona:5, consumoannuo:2000,importo:1016.68},{ zona:5, consumoannuo:5000,importo:2442.4} ,{ zona:6, consumoannuo:120,importo:114.68},{ zona:6, consumoannuo:480,importo:315.39},{ zona:6, consumoannuo:70,importo:430.84},{ zona:6, consumoannuo:1400,importo:798.19},{ zona:6, consumoannuo:2000,importo:1111.45},{ zona:5, consumoannuo:5000,importo:2674.88}]}
      ,lstModalitaPagamento :["1","2"]
      ,scontoRid:36 
      ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
      ,ImportoAnnuoLordo: 0
      ,ImportoAnnuoNetto: 0
      ,ImportoMensileLordo: 0
      ,ImportoMensileNetto: 0
      ,iscopertura: "" 
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/meiSimpleGas.ts